import React, { useEffect, useState } from "react";
import PageTitle from "../pageTitle/PageTitle";
import { Button, DatePicker, Space } from "antd";
import { submitButton } from "../../components/DesignStandardize";
import { Table } from "antd";
import { SnippetsOutlined } from "@ant-design/icons";
import axios from "axios";
import { apiUrl, isAdminLoggedIn } from "../../ApiUrlAndToken";
import { useSelector } from "react-redux";
import DownloadPurchaseItemReport from "../../components/DownloadPurchaseItemReport";

function PurchaseItemReport() {
  const jwt_token = useSelector((state) => state.global.jwt_token);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportData, setReportData] = useState({});
  const [generatedReport, setGeneratedReport] = useState([]);
  const getReport = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/reports/purchase-item-report/?start_date=${startDate}&end_date=${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${isAdminLoggedIn && jwt_token}`,
          },
        }
      );
      setReportData(response.data);
      setGeneratedReport(response.data.purchase_items);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [filteredInfo, setFilteredInfo] = useState({});

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
    setFilteredInfo(filters);
  };

  const clearFilters = () => {
    setFilteredInfo({});
  };
  const clearAll = () => {
    setFilteredInfo({});
  };

  const getUniqueFilterValues = (data, key) => {
    const uniqueValues = [...new Set(data.map((item) => item[key]))];
    return uniqueValues.map((value) => ({ text: value, value }));
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "purchase_date",
      sorter: {
        compare: (a, b) =>
          new Date(a.purchase_date) - new Date(b.purchase_date),
        multiple: 2,
      },
    },
    {
      title: "Purchase ID",
      dataIndex: "purchase_id",
      sorter: {
        compare: (a, b) => a.purchase_id - b.purchase_id,
        multiple: 1,
      },
      render: (purchase_id) => {
        return <p>000{purchase_id}</p>;
      },
      ellipsis: true,
    },
    {
      title: "Item Name",
      dataIndex: "item__name",
      sorter: {
        compare: (a, b) => a.item__name.localeCompare(b.item__name),
        multiple: 3,
      },
      filters: getUniqueFilterValues(generatedReport, "item__name"),
      filteredValue: filteredInfo.item__name || null,
      onFilter: (value, record) => record.item__name.includes(value),
    },
    {
      title: "Description",
      dataIndex: "purchase_remarks",
      sorter: {
        compare: (a, b) => a.purchase_remarks.localeCompare(b.purchase_remarks),
        multiple: 1,
      },
      filters: getUniqueFilterValues(generatedReport, "purchase_remarks"),
      filteredValue: filteredInfo.purchase_remarks || null,
      onFilter: (value, record) => record.purchase_remarks.includes(value),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      sorter: {
        compare: (a, b) => a.quantity - b.quantity,
        multiple: 3,
      },
      ellipsis: true,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: {
        compare: (a, b) => a.amount - b.amount,
        multiple: 3,
      },
      ellipsis: true,
    },
    {
      title: "Owner",
      dataIndex: "owner__first_name",
      sorter: {
        compare: (a, b) =>
          a.owner__first_name !== null ??
          a.owner__first_name.localeCompare(b.owner__first_name),
        multiple: 1,
      },
      filters: getUniqueFilterValues(generatedReport, "owner__first_name"),
      filteredValue: filteredInfo.owner__first_name || null,
      onFilter: (value, record) => record.owner__first_name.includes(value),
      render: (owner__first_name) => {
        return <p>{owner__first_name ? owner__first_name : "Null"}</p>;
      },
    },
    {
      title: "Business Partner",
      dataIndex: "purchase__business_partner__name",
      sorter: {
        compare: (a, b) =>
          a.purchase__business_partner__name.localeCompare(
            b.purchase__business_partner__name
          ),
        multiple: 3,
      },
      filters: getUniqueFilterValues(
        generatedReport,
        "purchase__business_partner__name"
      ),
      filteredValue: filteredInfo.purchase__business_partner__name || null,
      onFilter: (value, record) =>
        record.purchase__business_partner__name.includes(value),
    },
    {
      title: "Project",
      dataIndex: "purchase__sales_order__name",
      sorter: {
        compare: (a, b) =>
          a.purchase__sales_order__name.localeCompare(
            b.purchase__sales_order__name
          ),
        multiple: 1,
      },
    },
    {
      title: "Total Item Amount",
      dataIndex: "item_total_amount",
      sorter: {
        compare: (a, b) => a.item_total_amount - b.item_total_amount,
        multiple: 1,
      },
    },
    {
      title: "Total Purchase Amount",
      dataIndex: "purchase_total_amount",
      sorter: {
        compare: (a, b) => a.purchase_total_amount - b.purchase_total_amount,
        multiple: 1,
      },
    },
  ];

  return (
    <>
      <PageTitle title="Purchase Item Report" />
      <div className="mt-[7%] py-[40px] flex space-x-6 place-items-center">
        <div className="flex space-x-4">
          <div className="mb-4">
            <label
              htmlFor="start-date"
              className="block text-[20px] font-medium text-gray-700"
            >
              Start Date
            </label>
            <input
              type="date"
              id="start-date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="mt-1 p-[5px] block w-full rounded-md border-black/60 border-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-[14px]"
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="end-date"
              className="block text-[20px] font-medium text-gray-700"
            >
              End Date
            </label>
            <input
              type="date"
              id="end-date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="mt-1 p-[5px] block w-full rounded-md border-black/60 border-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-[14px]"
            />
          </div>
        </div>
        <button
          onClick={() => getReport()}
          className={`bg-white mt-[17px] border-slate-900/70 rounded-md text-slate-900/70 text-[17px] border-2 p-1`}
        >
          Generate Report <SnippetsOutlined />
        </button>
      </div>
      <div className="flex justify-between place-items-center">
        <Space
          style={{
            marginBottom: 16,
          }}
        >
          <Button onClick={() => clearFilters()}>Clear filters</Button>
          <Button onClick={() => clearAll()}>Clear filters and sorters</Button>
        </Space>
        <div className="flex place-items-center space-x-2  px-[20px]">
          <p className="text-[20px] text-black">
            Total Purchase Amount: {reportData?.total_purchase_amount} BDT
          </p>
          <DownloadPurchaseItemReport reportData={reportData} />
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={generatedReport}
        onChange={onChange}
        scroll={{
          x: 1800,
          y: 500,
        }}
        pagination={{
          pageSize: 10,
        }}
      />
    </>
  );
}

export default PurchaseItemReport;
